import { render, staticRenderFns } from "./TimeDetail.vue?vue&type=template&id=347009e3"
import script from "./TimeDetail.vue?vue&type=script&lang=ts"
export * from "./TimeDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports